const CustomLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="spinner"></div>
      <p>Loading, please wait...</p>
    </div>
  );
};

export default CustomLoader;
